module.exports = __webpack_public_path__ + "static/media/glace.f43172c6.svg";